// A single animated stat that counts up when scrolled into view.
export type Stat = {
    value: number;
    suffix: string;
    label: string;
};

// Headline numbers for the count-up strip; suffixes render after the number.
export const STATS: Stat[] = [
    { value: 20, suffix: "+", label: "Modules in one app" },
    { value: 4, suffix: "", label: "Roles, fully access-controlled" },
    { value: 1, suffix: "s", label: "Member check-in time" },
    { value: 100, suffix: "%", label: "Of your gym, covered" },
];
